import * as React from "react";
import "./OrderModal.css";

interface IOrderModalProps {
    isOpen: boolean;
    type: "success" | "error";
    message: string;
    onClose: () => void;
}

export const OrderModal: React.FC<IOrderModalProps> = ({ isOpen, type, message, onClose }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className="order-modal-overlay">
            <div className="order-modal-content">
                <h3 style={{ color: type === "success" ? "#4CAF50" : "#F44336" }}>
                    {type === "success" ? "Vielen Dank!" : "Fehler"}
                </h3>
                <p style={{ color: "#333", margin: "1.5rem 0" }}>{message}</p>
                <button 
                    className="button" 
                    style={{ backgroundColor: type === "success" ? "#4CAF50" : "#F44336", color: "white", border: "none", padding: "0.5rem 2rem", cursor: "pointer" }}
                    onClick={onClose}
                >
                    Schließen
                </button>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/visual/OrderModal.tsx